import { TokenSymbol } from '@/domain/types/TokenSymbol'

const eth = '/tokens/eth.svg?url'
const purr = '/tokens/purr.svg?url'
const susds = '/tokens/susds.svg?url'
const hfun = '/tokens/hfun.svg?url'
const solvbtc = '/tokens/solvBtc.png'
const sttesth = '/tokens/sttesth.svg?url'
const wsthype = '/tokens/wsthype.svg?url'
const usde = '/tokens/usde.png'
const lhype = '/tokens/lhype.png'
const buddy = '/tokens/buddy.jpg'
const feusd = '/tokens/feusd.svg?url'
const mhype = '/tokens/mhype.png'
const ubtc = '/tokens/ubtc.png'
const usdxl = '/tokens/usdxl.svg?url'
const usdh = '/tokens/usdh.svg?url'
const usdhl = '/tokens/usdhl.png'
const susde = '/tokens/susde.svg?url'
const hype = '/tokens/hype.png'
const ueth = '/tokens/ueth.png'
const steth = '/tokens/steth.svg?url'
const unknown = '/tokens/unknown.svg?url'
const usdc = '/tokens/usdc.svg?url'
const usdt0 = '/tokens/usdt0.svg?url'
const khype = '/tokens/khype.svg?url'
const hbhype = '/tokens/hbhype.svg?url'
const stkusdxl = '/tokens/stkusdxl.svg?url'
const cmeth = '/tokens/cmeth.png'
const usol = '/tokens/usol.png'
const xaut0 = '/tokens/xaut0.svg?url'
const hwhlp = '/tokens/hwhlp.svg?url'
const whlp = '/tokens/whlp.png'
const hlp0 = '/tokens/hlp0.png'
const upump = '/tokens/upump.svg?url'
const ptkhype = '/tokens/pt-khype.svg?url'
const thbill = '/tokens/thbill.png'
const hahype = '/tokens/hahype.png'
const hbusdt = '/tokens/hbusdt.jpg'
const ptvkhype = '/tokens/pt-vkhype.svg?url'
const behype = '/tokens/behype.svg?url'
const bbhlp = '/tokens/bbhlp.svg?url'
const lsthype = '/tokens/lsthype.svg?url'
const ufart = '/tokens/fartcoin.svg?url'
const hwhype = '/tokens/hwhype.svg?url'
const usdp = '/tokens/usdp.png'
const xhype = '/tokens/xhype.svg?url'
const susn = '/tokens/susn.png'
const usdg0 = '/tokens/usdg0.png'

/* Opengraph does not support webp */
export const tokens = {
  eth,
  weth: eth,
  purr,
  susds,
  hfun,
  steth,
  usdc,
  usdt0,
  usdxl,
  susde,
  hype,
  whype: hype,
  hwhype,
  solvbtc,
  sttesth,
  khype,
  wsthype,
  sthype: wsthype,
  ubtc,
  ueth,
  lhype,
  buddy,
  feusd,
  usde,
  mhype,
  xlhype: lhype,
  hbhype,
  stkusdxl,
  cmeth,
  usol,
  xaut0,
  hwhlp,
  whlp,
  hlp0,
  upump,
  ptkhype,
  thbill,
  hahype,
  hbusdt,
  ptvkhype,
  behype,
  bbhlp,
  usdh,
  lsthype,
  ufart,
  usdp,
  susdp: usdp,
  xhype,
  usdhl,
  susn,
  usdg0,
  unknown,
}

function tokenSymbolOverride(symbol: TokenSymbol): TokenSymbol {
  switch (symbol) {
    case TokenSymbol('USD₮0'):
      return TokenSymbol('USDT0')
    case TokenSymbol('PT-kHYPE'):
    case TokenSymbol('PT-kHYPE-13NOV2025'):
    case TokenSymbol('PT-kHYPE-19MAR2026'):
      return TokenSymbol('ptkHYPE')
    case TokenSymbol('PT-hwHLP'):
    case TokenSymbol('PT-HWHLP-18DEC2025'):
      return TokenSymbol('hwHLP')
    case TokenSymbol('PT-vkHYPE'):
    case TokenSymbol('PT-vkHYPE-13NOV2025'):
      return TokenSymbol('ptvkHYPE')
    default:
      return symbol
  }
}

const SPOT_ASSET_PREFIX = 'https://app.hyperliquid.xyz/coins/'

export function getHyperliquidImage(symbol: TokenSymbol): string {
  return `${SPOT_ASSET_PREFIX}${symbol.toUpperCase()}_USDC.svg`
}

export function getTokenImage(symbol: TokenSymbol, host?: string, isL1?: boolean): string {
  const image = tokens[tokenSymbolOverride(symbol).toLocaleLowerCase() as keyof typeof tokens]

  if (!image) {
    // Only try Hyperliquid icon URLs for L1 tokens; EVM-only tokens go straight to the unknown fallback
    if (isL1) {
      return getHyperliquidImage(symbol)
    }
    return host ? `${host}${tokens.unknown}` : tokens.unknown
  }

  return host ? `${host}${image}` : image
}
